import { atom } from 'jotai';

export const pendingOptimisticUpdatesState = atom<Set<string>>(
  new Set<string>()
);
